var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9259 23.7154L12.0726 25.185V15.4772H1.9259V23.7154ZM1.9259 14.0905H12.0726V4.38168L1.9259 5.8513V14.0905ZM13.4593 25.386L27.0741 27.3579V15.4772H13.4593V25.386ZM13.4593 4.18014V14.0905H27.0741V2.20923L13.4593 4.18014Z",
    fill: "#4D0B0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsIcon);
export default __webpack_public_path__ + "static/media/windows_icon.5d0878e2ba00c8c0e4d8e8916bd441ae.svg";
export { ForwardRef as ReactComponent };